module.exports = __webpack_public_path__ + "assets/icon-animalType-pig.8bab5c06.svg";